import React from "react";
import "./index.scss";

import {
  CustomBadges,
  CustomIcon,
  ShowConfirm,
  TableNullData,
  UserInformation,
} from "../../../../components";
import Context from "../../../../context";
import { GRADE, SCHOOL_GENDER } from "../../../../values/dropdownItems";
import utils from "../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {
  // ========================================== JSX Content =============================================
  const { setSelectedSchool, setShowModal } = React.useContext(
    Context.SchoolScreen
  );

  function onClick(school: any) {
    setSelectedSchool(school);
    setShowModal("SHOW_INFORMATION");
  }

  function onUpdate(school: any) {
    setSelectedSchool(school);
    setShowModal("UPDATE");
  }

  // function onDelete(school: any) {
  //   setSelectedSchool(school);
  //   setShowModal("DELETE");
  // }

  function onApprove(school: any) {
    setSelectedSchool(school);
    setShowModal("APPROVE");
  }

  function onReject(school: any) {
    setSelectedSchool(school);
    setShowModal("REJECT");
  }
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const { t } = useTranslation();

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="school-table-body-container">
      {data?.map((school: any, index: number) => {
        return (
          <tr key={`school-${index}`}>
            <td className="pointer" onClick={() => onClick(school)}>
              <UserInformation
                name={school?.name}
                avatar={school?.avatar}
                isBlock={!school?.approved}
                phoneNumber={school?.telephone}
              />
            </td>
            <td onClick={() => onClick(school)}>
              {t(
                SCHOOL_GENDER.find((item) => item.value === school?.gender)
                  ?.name as string
              )}
            </td>
            <td onClick={() => onClick(school)}>
              {t(
                school?.grade.map(
                  (item: any, index: number) =>
                    (GRADE.find((gradeItem) => item.grade === gradeItem?.value)
                      ?.name as string) +
                    (index + 1 < school?.grade.length ? " - " : "")
                )
              )}
            </td>
            <td onClick={() => onClick(school)}>
              <CustomBadges title={school?.city?.name} type="primary" />
            </td>
            <td onClick={() => onClick(school)}>
              <CustomBadges title={school?.province?.name} type="primary" />
            </td>
            <td className="pointer">
              <ShowConfirm
                icon="fa-solid fa-school"
                isConfirm={school?.approved}
                title={school?.approved ? t("approved") : t("disApproved")}
              />
            </td>
            <td>
              {/* {!school?.approved && userType !== "COMPANY" && (
                <CustomIcon
                  icon="fas fa-check"
                  hoverTitle="تایید کردن"
                  onClick={() => onApprove(school)}
                />
              )} */}
              {writePermission === "true" && (
                <div className="table-actions-buttons">
                  {/* Edit Icon */}
                  <CustomIcon
                    icon="fas fa-pen"
                    hoverTitle={t("update")}
                    onClick={() => onUpdate(school)}
                  />
                  {/* Delete Modal */}
                  {/* <CustomIcon icon="fas fa-trash" hoverTitle="حذف" onClick={() => onDelete(school)} /> */}
                  {/* Block Icon */}
                  {school?.approved === true ? (
                    <CustomIcon
                      icon="fas fa-ban"
                      hoverTitle={t("disApprove")}
                      onClick={() => onReject(school)}
                    />
                  ) : (
                    <CustomIcon
                      icon="fas fa-check"
                      hoverTitle={t("approve")}
                      onClick={() => onApprove(school)}
                    />
                  )}
                </div>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
